module.exports = __webpack_public_path__ + "img/terreno_bueno.9c53eb25.gif";